export class BankPaymentDetailDto {

    amount: number;
    bankBranch: string;
    bankName: string;
    chequeDate: string;
    chequeNoUTRNo: string;
    ifscCode: string;
    bankAccountCode: number;
    refNo: string;
    bankRefCode: string;
}
